import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vueCustomElement from 'vue-custom-element'
import DataLayer from './plugins/DataLayer'
import './filters'


// note: multiple instances of this element will share this store
// if that is not desirable, there a a couple limited option
// 1. do not use Vuex
// 2. try to use something like dynamic module registration https://vuex.vuejs.org/guide/modules.html#dynamic-module-registration
App.store = store

Vue.use(vueCustomElement)
Vue.use(DataLayer, { debug: process.env.NODE_ENV !== 'production' })
Vue.customElement('pce-dealerheader', App)